import { Map } from 'immutable';
import { actionTypes } from '../../../../controller';

const {
	TRIGGER_LOG_EVENT,
} = actionTypes;
const initialState = Map({
	eventDataMap: Map(),
});

export default function logger(state = initialState, action) {
	switch (action.type) {
		case TRIGGER_LOG_EVENT:
			return state
				.set('eventDataMap', action.eventData);
		default:
			return state;
	}
}
